import React from "react";
import "./CompanyAndSharesResult.css";
import { Text, View, Link } from "@react-pdf/renderer";
import { styles } from "../styles/Slide10Styles";

export function Slide10() {
  return (
    <View style={styles.backgroundBlue}>
      <View style={styles.slideContainer}>
        <View style={styles.columnLeft}>
          <Text style={styles.subTitle}>Need Help?</Text>
          <Text style={styles.paragraph}>
            If you have any questions, concerns, honest feedback or need further
            assistance, please do not hesitate to contact us via{" "}
            <Link src={"mailto: info@mace-legal.com"}>
              <Text style={styles.link}>info@mace-legal.com</Text>
            </Link>
            .
          </Text>
          <Text style={styles.subTitle}>Shareholders’ agreement</Text>
          <Text style={styles.paragraph}>
            The co-founder alignment provided by this tool is the intellectual
            exercise of an important part of the shareholders’ agreement applied
            in early-stage funding which typically also contains other
            arrangements with related to the transfers of shares (restrictions &
            free transfers), the governance of the company (the board, reserved
            matters, …), certain restrictive covenants (non-compete,
            non-solicitation, …) and more. To incorporate this exercise into a
            fully fledged shareholders' agreement, it can be helpful to schedule
            a dedicated meeting where all stakeholders can participate and deal
            with all the topics. The exercise should be led by an experienced
            facilitator who can guide the group through various scenarios and
            help to identify areas of potential misalignment.
          </Text>
        </View>
        <View style={styles.columnRight}>
          <Text style={styles.subTitle}>Disclaimer</Text>
          <Text style={styles.paragraph}>
            Please note that the information provided in this exercise regarding
            co-founder alignment is intended for informational & educational
            purposes only and should not be construed as legal or professional
            advice. While this exercise may provide some helpful insights and
            suggestions, it is not intended to be a comprehensive or exhaustive
            guide to addressing co-founder alignment within a shareholders'
            agreement. In addition, while we have made efforts to make this
            exercise accessible and visual, we cannot guarantee its accuracy or
            completeness. It is important to consult with legal or professional
            advisors before making any binding decisions related to co-founder
            alignment or any other legal or business matters. We do not accept
            any responsibility for any loss or damage that may arise from your
            use of this exercise or any reliance on the information provided.
          </Text>
          <Text style={styles.paragraph}>
            Depending on the choices made in this tool, certain outcomes may
            have tax consequences which can vary depending on your individual
            circumstances and the jurisdiction in which you are located. It is
            recommended to consult with a qualified tax professional before
            taking any action based on the information provided. We do not
            accept any responsibility for any loss or damage that may arise from
            your use of this tool or any reliance on the information provided in
            this regard.
          </Text>
        </View>
      </View>
    </View>
  );
}
